<!--
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-08 19:40:37
 * @LastEditTime: 2019-08-09 11:32:44
 * @Version: 1.0
 * @Description: 描述
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->
<template>
  <!--企业展示-->
  <div>
    <!--banner-->
    <section class="logo-wrap">
      <article class="logo">
        <img src="@/assets/img/enterprise/banner.png" alt="">
      </article>
    </section>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<style scoped lang='scss'>
  .logo-wrap{
    width: 100%;
    img{
      width: 100%;
    }
  }
</style>
<script type="text/ecmascript-6">
export default {
  name: 'Dynamic'
}
</script>
